import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardHeader from 'components/Card/CardHeader.js';
import TablaObjetos from 'views/Grillas/ObjetosGrilla';

function Objetos() {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', pt: '120px' }}>
      <Card>
        <CardHeader>
          <Typography variant="h6" fontWeight="bold" color="text.primary">
            Objetos del Sistema
          </Typography>
          <Divider sx={{ mt: 1 }} />
        </CardHeader>
        <CardBody>
          <TablaObjetos />
        </CardBody>
      </Card>
    </Box>
  );
}

export default Objetos;
